import { DatasetsApi } from '@api';
import { ExistingFile, NewFile, UploadedFile } from '@types';

import { ErrorHelper } from './error';

const createAudioRecordings = async (recordings: UploadedFile[], datasetsApi: DatasetsApi): Promise<number[]> => {
  const results = await Promise.all(
    recordings.map(async (recording: UploadedFile) => {
      if ('documentId' in recording && (recording as ExistingFile).documentId != null) {
        return (recording as ExistingFile).documentId as number;
      }
      try {
        const created = await datasetsApi.apiDatasetsAudioRecordingsCreate({
          fileName: recording.name,
          file: (recording as NewFile).file,
        });
        return created.id;
      } catch (error) {
        ErrorHelper.handleErrorNotification(error);
        return null;
      }
    }),
  );

  return results.filter((id): id is number => id != null);
};

export const AudioRecordingsHelper = {
  createAudioRecordings,
};
